import { Component, Input, OnInit } from "@angular/core";
import { QuestionEntity } from "src/app/models/new-product/base/question-entity.model";
import { ProposalConst } from "src/app/models/new-product/sme/mortgage-fire/singapore/base/mf-sg-proposal-constant";

@Component({
    selector: "percentage-box-v1-question",
    templateUrl: "./percentage-box-v1-question.component.html",
    styleUrls: ["./percentage-box-v1-question.component.scss"],
    standalone: false
})
export class PercentageBoxV1QuestionComponent implements OnInit {
  noAnswerDefaultText = ProposalConst.noAnswerDefaultText;
  @Input() public question!: QuestionEntity;
  @Input() public noAnsCustomDefaultText?: string;
  @Input() public numberOfDecimalPlace?: number = 2;
  @Input() public displayMultiplier: number = 1;

  constructor() {}

  ngOnInit(): void {}

  //https://stackoverflow.com/questions/40341648/angular-2-how-to-bind-input-to-model-property-with-getter-and-setter-methods
  // Getter method
  public get QuestionAnswerFormatted() {
    //HE-160: for future
    if (this.question.answer === undefined) {
      return 0;
    }
    return Number(this.question.answer);
  }

  // Setter method
  public set QuestionAnswerFormatted(val: number) {
    // strip out all the currency information
    //const revenueVal = val.replace(/[^\d]/g, '');
    //this.AnnualRevenue = parseInt(revenueVal);
    this.question.answer = String(val);
  }

  public noAnsDefText() {
    if (this.noAnsCustomDefaultText) {
      return this.noAnsCustomDefaultText;
    }

    return this.noAnswerDefaultText;
  }

  public noOfDecimalPlace(): number {
    if (this.numberOfDecimalPlace != undefined) {
      return this.numberOfDecimalPlace!;
    }

    return 2;
  }

  padDigits(digits: number) {
    return Array(Math.max(digits + 1, 0)).join("0");
  }

  decimalPlaceFormat() {
    let dp = this.noOfDecimalPlace();
    return "##." + this.padDigits(dp) + " \\%";
  }
}
